import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../services/auth.service";
import { AbilityNameList } from "../interfaces/ability/ability-name-list.model";

export const hasPermissionToLoadGuard: CanActivateFn = (route, state): Observable<boolean> => {
    const authService = inject(AuthService);
    const requiredPermission = route.data["requiredPermission"] as
        | keyof typeof AbilityNameList
        | (keyof typeof AbilityNameList)[];

    return authService.hasPermission(requiredPermission);
};
